// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { BeneficiaryType } from 'types/beneficiaries'
import { SidePanelBodyDataProps } from './MassPayoutSidePanel'

export type MassPayoutSidePanelBodyProps = {
  sidePanelBodyData: SidePanelBodyDataProps
  isB2CPayout: boolean
}

export const MassPayoutSidePanelBody = ({
  sidePanelBodyData,
  isB2CPayout,
}: MassPayoutSidePanelBodyProps) => {
  const { t } = useTranslation()
  const sidePanelData = sidePanelBodyData?.preProcessedPayout?.details?.beneficiary

  // Beneficiary Details
  const accountNumber = sidePanelData?.bankAccount?.accountNumber
  const bankCode = sidePanelData?.bankAccount?.bankCode
  const bankCountry = sidePanelData?.bankAccount?.bankCountry
  const dateOfBirth = sidePanelData?.entity?.dateOfBirth
  const beneficiaryType = sidePanelData?.type
  const isFirstParty = beneficiaryType === BeneficiaryType.FIRST_PARTY
  const beneficiaryTypeLabel = isFirstParty ? t('internal') : t('external')
  const countryOfRegistration = sidePanelData?.entity?.country
  const entityType = isB2CPayout
    ? t('manageBeneficiaries.individual')
    : t('manageBeneficiaries.business')

  return (
    <Box>
      <h4 className="text-h4 text-foreground-prominent">{t('bankDetails')}</h4>
      <Box paddingT={8} paddingB={12}>
        {accountNumber && (
          <DataListItem
            id="account-number"
            testId="account-number"
            title={t('accountNumber')}
            body={ellipseMiddleText(accountNumber, 8, 8)}
            copyText={accountNumber}
          />
        )}
        {bankCode && (
          <DataListItem
            id="bank-code"
            testId="bank-code"
            title={t('bankCode')}
            body={ellipseMiddleText(bankCode, 20, 10)}
            copyText={bankCode}
          />
        )}
        {bankCountry && (
          <DataListItem
            id="bank-country"
            testId="bank-country"
            title={t('bankCountry')}
            body={bankCountry}
          />
        )}
      </Box>

      <Box>
        <h4 className="text-h4 text-foreground-prominent">{t('massPayouts.beneficiaryDetails')}</h4>
        <Box paddingT={8} paddingB={8}>
          {dateOfBirth && (
            <DataListItem
              id="date-of-birth"
              testId="date-of-birth"
              title={t('formFields.dateOfBirth')}
              body={dateOfBirth}
            />
          )}
          {beneficiaryType && (
            <DataListItem
              id="beneficiary-type"
              testId="beneficiary-type"
              title={t('manageBeneficiaries.beneficiaryType')}
              body={beneficiaryTypeLabel}
            />
          )}
          {entityType && (
            <DataListItem
              id="entity-type"
              testId="entity-type"
              title={t('manageBeneficiaries.entityType')}
              body={entityType}
            />
          )}
          {countryOfRegistration && (
            <DataListItem
              id="country-of-registration"
              testId="country-of-registration"
              title={t('massPayouts.countryOfRegistration')}
              body={countryOfRegistration}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}
